export const getCTAandWIAPIPositions = (viewportWidth, isGridLayout) => {
	const isTwoColumnGrid = viewportWidth < 1440 && isGridLayout;
	// index at which CTA and WIAPI cards are inserted into list of vehicles
	let firstPosition = 1; // list view case / smallscreen case
	if (isTwoColumnGrid) {
		firstPosition = 2; // grid view with 2 columns case
	} else if (isGridLayout) {
		firstPosition = 3; // grid view with 3 columns case
	}

	return [
		firstPosition,
		6,
		isTwoColumnGrid ? 10 : 9,
		isTwoColumnGrid ? 14 : 12
	];
};
